/*
  iOS 개발 시 iOS Native 에 화면 이전 시 데이터 전송을 위해 처리된 파일입니다.
  상세 페이지나 BackPage 등의 Native 로 이벤트를 보내야 하는 이동은 해당 코드와 iOS AppDelegate 를 참고하시면 됩니다.
 */
import store from '../../store'
import Config from '../../config'
class DynamicNavigator {
  static instance

  isiOS () {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
  }

  static getInstance () {
    if (!this.instance) {
      this.instance = new DynamicNavigator()
    }

    return this.instance
  }

  moveToDetail (url, router) {
    if (store.state.APP.IS_NATIVE) {
      if (this.isiOS()) {
        window.open(url)
      } else {
        router.push(url)
      }
    } else {
      window.open(url, '_blank')
    }
  }

  detailToBack (router) {
    const domain = process.env.NODE_ENV === 'development' ? Config.DOMAIN.DEVELOPMENT : Config.DOMAIN.PRODUCTION

    if (
      this.isiOS() &&
      store.state.APP.IS_NATIVE &&
      window.cordova.hasOwnProperty('exec')
    ) {
      window.open('IOS://MOVE_TO_BACK')
    } else if (document.referrer && document.referrer.indexOf(domain) > -1) {
      window.close()
      router.back()
    } else {

      router.back()
    }
  }

  moveToMap (url, router) {
    if (store.state.APP.IS_NATIVE && this.isiOS()) {
      window.open(url)
    } else {
      router.push(url)
    }
  }

  moveToHomePage (url) {
    if (store.state.APP.IS_NATIVE && this.isiOS()) {
      console.log(url)
      window.open(`ios-homepage://${encodeURIComponent(url)}`, '_blank')
    } else {
      window.open(url, '_blank')
    }
  }
}

export default DynamicNavigator
